import React, { useState, useEffect } from 'react';
import './DynamicCollage.css';
import loop from '../videos/loop.mp4';

const HeroAnimacion = () => {

  useEffect(() => {
  }, []);

  return (
      <div className="video-container">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="background-video"
        >
          <source src={loop} type="video/mp4" />
        </video>
      </div>
  );
};

export default HeroAnimacion;